import CloseIcon from '@mui/icons-material/Close';
import styled, { css } from 'styled-components';

import { HEADER_Z_INDEX } from 'components/b2c/Header/Header.style';
import { TIME_SLIDER_Z_INDEX } from 'components/b2c/Mp3KbpPlayer/components/TimeSlider/TimeSlider.style';
import { fontFamily } from 'stylesheet';
import {
  colorUsage,
  getSpacing,
  borderRadius,
  bamScrollbarStyle,
  addDesktopDesignStyle,
} from 'stylesheetB2c';

const MODAL_WIDTH = 320;
const MODAL_OPACITY = 0.95;
const VERTICAL_PADDING_IN_PERCENTAGE = 15;

interface ModalProps {
  isOpen?: boolean;
  bamOnlineStyle?: boolean;
}

export const ModalBackground = styled.div<ModalProps>`
  visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  left: 0;
  right: 0;
  top: 0;
  height: 100%;
  padding: 0 ${getSpacing(5)};
  pointer-events: ${(props) => (props.isOpen ? 'all' : 'none')};
  transition: all 0.1s ease;
  overflow: hidden;
  ${({ bamOnlineStyle }) =>
    bamOnlineStyle &&
    css`
      background-color: ${colorUsage.bamOnline.modal.backdrop};
      z-index: ${HEADER_Z_INDEX + 1};
    `}
`;

ModalBackground.displayName = 'ModalBackground';

export const ModalContainer = styled.div<ModalProps>`
  width: 100%;
  max-width: ${MODAL_WIDTH}px;
  max-height: ${(props) => (props.isOpen ? `${100 - 2 * VERTICAL_PADDING_IN_PERCENTAGE}%` : '0')};
  overflow-y: hidden;
  transition: all 0.3s ease;
  border-radius: ${borderRadius.XLarge};
  position: relative;

  /* Setting z-index here prevents mp3-kbp player time slider to
  be displayed on top of modals  */
  z-index: ${TIME_SLIDER_Z_INDEX + 1};

  /* padding is defined both here and in ModalContent
  to place the scrollbar correctly */
  padding: ${getSpacing(5)} ${getSpacing(1)};

  /* padding cannot be height percentage so we use top property to space element here */
  top: ${(props) => (props.isOpen ? `${VERTICAL_PADDING_IN_PERCENTAGE}%` : '100%')};
  ${({ isOpen, bamOnlineStyle }) =>
    bamOnlineStyle
      ? css`
          background-color: ${colorUsage.bamOnline.modal.background};
          font-family: ${fontFamily.bamOnline};
          color: ${colorUsage.bamOnline.modal.text};
          ${addDesktopDesignStyle(css`
            top: ${isOpen ? '50%' : '100%'};
            transform: translateY(-50%);
          `)};
        `
      : css`
          background-color: ${colorUsage.modalBackgroundColor};
          opacity: ${isOpen ? MODAL_OPACITY : 0};
        `}
`;
ModalContainer.displayName = 'ModalContainer';

const bamCloseIconStyle = css`
  cursor: pointer;
  position: absolute;
  top: 12px;
  right: 12px;
`;

export const WhiteBamCloseIcon = styled(CloseIcon)`
  color: ${colorUsage.whiteText};
  ${bamCloseIconStyle}
`;
WhiteBamCloseIcon.displayName = 'WhiteBamCloseIcon';

export const BlackBamCloseIcon = styled(CloseIcon)`
  color: ${colorUsage.bamOnline.modal.closeIcon};
  ${bamCloseIconStyle}
`;
BlackBamCloseIcon.displayName = 'BlackBamCloseIcon';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  max-height: 100%;
  padding: 0 ${getSpacing(4)};
  ${bamScrollbarStyle}
`;

ModalContent.displayName = 'ModalContent';
